import axios from "../helpers/axioxInstance";
import URLS from "../constData/urls";

const tableURLMapping = {
  drmBidTableData: URLS.DRM_BID_TABLE_DATA_UPDATE,
  drmDailyTableData: URLS.DRM_DAILY_CREATE_UPDATE
};
export const drmUpdateTableData = async ([
  updatedTableDataList,
  tableName,
  controller,
]) => {
  const response = await axios.post(
    `${tableURLMapping[tableName]}`,
    updatedTableDataList,
    { signal: controller.signal }
  );

  if (response.status >= 504) {
    throw new Error('gateway_timeout_error');
  }

  if (response.status >= 400) {
    throw new Error(response.message);
  }
  return response;
};
